<template>
  <div :class="['partner-logo', containerClass]">
    <v-img
      v-if="src"
      :src="src"
      :alt="alt"
      contain
      eager
    >
      <template #placeholder>
        <div class="d-flex align-center justify-center fill-height">
          <v-progress-circular
            indeterminate
            size="20"
            width="2"
            color="grey lighten-1"
          />
        </div>
      </template>
    </v-img>
    <v-icon
      v-else
      :size="fallbackIconSize"
      color="grey"
    >
      mdi-domain
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'PartnerLogoBlock',

  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: '',
    },
    fallbackIconSize: {
      type: Number,
      default: 40,
    },
  },
};
</script>
